export default __webpack_public_path__ + "static/media/frg--fitness-centre.df0ed8bd.png";